import React, { useEffect, useState } from "react";
import ListHeader from "../../../../../components/listing/ListHeader";
import ListFooter from "../../../../../components/listing/ListFooter";
import DynamicTable from "../../../../../components/listing/DynamicTable";
import FiltroCiudad from "./FiltroCiudad";
import apiRoutes from "../../../../../api/apiRoutes";
import { appFetchJson } from "../../../../../utils/http";
import IconEdit from "../../../../../components/icons/IconEdit";
import IconTrash from "../../../../../components/icons/IconTrash";
import CrearCiudad from "./CrearCiudad";
import EditarCiudad from "./EditarCiudad";
import EliminarCiudad from "./EliminarCiudad";

export default function ListarCiudad() {
  const [porPagina, setPorPagina] = useState(30);
  const [pagina, setPagina] = useState(1);
  const [totalBackend, setTotalBackend] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [ciudadAEditar, setCiudadAEditar] = useState(null);
  const [ciudadAEliminar, setCiudadAEliminar] = useState(null);
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [filtros, setFiltros] = useState({
    nombre: "", codigo: "", nombrePais: "", departamentoId: ""
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = apiRoutes.ciudades.listUrl({
          page: pagina - 1,
          size: porPagina,
          nombre: filtros.nombre.trim() || undefined,
          codigo: filtros.codigo.trim() || undefined,
          nombrePais: filtros.nombrePais.trim() || undefined,
          departamentoId: filtros.departamentoId || undefined,
        });
        const res = await appFetchJson(url);
        const items = Array.isArray(res?.items) ? res.items : [];
        setData(items);
        setTotalBackend(res?.totalElements ?? res?.total ?? items.length);
      } catch (e) {
        console.error("Error cargando ciudades:", e);
        setError("Error al cargar las ciudades.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [pagina, porPagina, filtros, reloadKey]);

  const columns = [
    { header: "Nombre", accessor: "nombre", type: "text", width: "20%", cellClass: "font-medium text-gray-800 break-words" },
    { header: "Código", accessor: "codigo", type: "text", width: "15%", cellClass: "text-gray-600" },
    { header: "País", accessor: "nombrePais", type: "text", width: "15%", cellClass: "text-gray-600" },
    { header: "Departamento", accessor: "departamentoNombre", type: "text", width: "30%", cellClass: "text-gray-600" },
    {
      header: "Acción", type: "action", width: "20%",
      render: (row) => (
        <div className="flex justify-center items-center gap-2">
          <button title="Editar" onClick={() => setCiudadAEditar(row)}><IconEdit /></button>
          <button title="Eliminar" onClick={() => setCiudadAEliminar(row)}><IconTrash /></button>
        </div>
      ),
    },
  ];

  return (
    <div className="page">
      <ListHeader
        title="Ciudades"
        filters={filtros}
        onFilterClick={() => setMostrarFiltros(true)}
        onClearFilters={() => { setFiltros({ nombre: "", codigo: "", nombrePais: "", departamentoId: "" }); setPagina(1); }}
        showAdd={true}
        addLabel="Agregar"
        onAddClick={() => setMostrarCrear(true)}
        pageSize={porPagina}
        onPageSizeChange={(size) => { setPorPagina(size); setPagina(1); }}
      />

      {loading && <div className="mt-2 text-sm text-gray-600">Cargando datos...</div>}
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}

      {mostrarFiltros && (
        <FiltroCiudad
          initialFilters={filtros}
          onSubmit={(nuevos) => { setFiltros(nuevos); setPagina(1); setMostrarFiltros(false); }}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      <DynamicTable size="S" data={data} columns={columns} />

      <ListFooter
        page={pagina}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={(p) => setPagina(p)}
      />

      {mostrarCrear && (
        <CrearCiudad
          onClose={() => setMostrarCrear(false)}
          onCreated={() => { setPagina(1); setReloadKey(k => k + 1); setMostrarCrear(false); }}
        />
      )}

      {ciudadAEditar && (
        <EditarCiudad
          initial={ciudadAEditar}
          onClose={() => setCiudadAEditar(null)}
          onSaved={() => { setReloadKey(k => k + 1); setCiudadAEditar(null); }}
        />
      )}

      {ciudadAEliminar && (
        <div className="modal-backdrop" onClick={() => setCiudadAEliminar(null)}>
          <div className="modal-panel-md" onClick={e => e.stopPropagation()}>
            <EliminarCiudad
              registro={ciudadAEliminar}
              onClose={() => setCiudadAEliminar(null)}
              onDeleted={() => { setReloadKey(k => k + 1); setCiudadAEliminar(null); }}
            />
          </div>
        </div>
      )}
    </div>
  );
}